
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';

import { login, signup, logout, clearErrorsAction, googleLogin } from '../../actions/session_actions';

import { forgotPassword } from '../../actions/user_actions';

import RegisterHomePage from './register_home_page';

const mapStateToProps = (state, ownProps) => {

  const loggedIn = Boolean(state.session.currentUser)
  let currentUser = loggedIn ? state.session.currentUser : null;
  let errors = state.errors.session;

  return {
    currentUser,
    loggedIn,
    errors
  };
};

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
  signup: user => dispatch(signup(user)),
  login: user => dispatch(login(user)),
  clearErrors: user => dispatch(clearErrorsAction()),
  googleLogin: token => dispatch(googleLogin(token)),
  forgotPassword: data => dispatch(forgotPassword(data)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RegisterHomePage));
